<nz-spin [nzSpinning]="loading$ | async">
  <div class="drawer-form-wrapper">
    <div class="behaviour-card-sec" *ngIf="caseDetail && caseDetail.student">
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{ caseDetail.student.firstName }} {{ caseDetail.student.lastName }}
        </h3>
      </div>
      <div class="card-content-wrapper">
        <div class="content">
          <h4 class="title">Date Of Birth</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-calendar.svg"
              class="icon s-16"></svg-icon>
            {{ caseDetail.student.dateOfBirth | date: 'MM/dd/yyyy' }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Supervisor</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-supervisor.svg"
              class="icon s-16"></svg-icon>
            {{ caseDetail.caseOwnerName }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Gender</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-male.svg"
              class="icon s-18"></svg-icon>
            {{ caseDetail.student.gender }}
          </p>
        </div>
      </div>
    </div>
    <div [ngSwitch]="stepNumber">
      <div *ngSwitchCase="0">
        <nz-form-item>
          <nz-form-label nzFor="operationalDefinition">
            Operational Definition
          </nz-form-label>
          <nz-form-control>
            <textarea
              id="operationalDefinition"
              name="operationalDefinition"
              rows="4"
              nz-input
              placeholder="Operational Definition"
              [disabled]="true"
              [value]="
                caseDetail.caseBehaviors[0].operationalDefinition
              "></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-divider />

        <div class="header-with-cta mb-24">
          <div class="quetion-badge">
            <span class="badge"> {{ currentQuestion + 1 }}/16 </span>
            <h3 class="title s-18">Question</h3>
          </div>
        </div>
        <form [formGroup]="functionalAssessmentForm">
          <ng-container formArrayName="questions">
            <ng-container *ngIf="questions.controls[currentQuestion]">
              <ng-container
                [formGroup]="behaviorQuestionControl[currentQuestion]">
                <nz-form-item>
                  <nz-form-label nzRequired="true">
                    <p class="form-desc">
                      {{
                        fbaQuestionList[currentQuestion].question
                          | genderReplace
                            : caseDetail.student.firstName
                            : caseDetail.student.gender
                      }}
                    </p>
                  </nz-form-label>
                  <nz-form-control>
                    <div class="radio-wrapper">
                      <nz-radio-group
                        id="behaviourQuestions"
                        nzName="behaviourQuestions"
                        formControlName="functionalAssessmentAnswerId">
                        <span
                          *ngFor="
                            let answer of fbaQuestionList[currentQuestion]
                              .functionalAssessmentAnswers
                          "
                          [id]="answer.id"
                          nz-radio
                          class="box-radio"
                          [nzValue]="answer.id">
                          {{
                            answer.answer
                              | genderReplace
                                : caseDetail.student.firstName
                                : caseDetail.student.gender
                          }}
                        </span>
                      </nz-radio-group>
                    </div>
                  </nz-form-control>
                  <div
                    class="ant-form-item-explain-error mt-3"
                    *ngIf="
                      questions.controls[currentQuestion]
                        .get('functionalAssessmentAnswerId')
                        ?.hasError('required')
                    ">
                    Please select answer.
                  </div>
                </nz-form-item>
              </ng-container>
            </ng-container>
          </ng-container>
        </form>
      </div>
      <form
        nz-form
        class="form"
        nzLayout="horizontal"
        [formGroup]="functionalAssessmentForm"
        *ngSwitchCase="1">
        <nz-form-item>
          <nz-form-label nzRequired="true">
            <p class="form-desc">
              You have indicated that one of the possible functions of this
              behavior is escape, meaning to avoid, delay, or get out of certain
              tasks, activities, or settings. To help us identify more specific
              interventions that are most likely to help, please answer the
              following question:<br /><br />
              Is {{ caseDetail.student.firstName }} more likely to try escaping
              from social situations and interactions with peers, or from tasks
              and demands placed on
              {{ caseDetail.student.gender === 'Female' ? 'her' : 'him' }}
              by adults?
            </p>
          </nz-form-label>
          <div class="radio-wrapper">
            <nz-radio-group
              id="languageLevel"
              nzName="radiogroup"
              formControlName="levelEscape">
              <span nz-radio nzValue="Peers" class="box-radio"> Peers </span>
              <span nz-radio nzValue="Adults" class="box-radio"> Adults </span>
              <span nz-radio nzValue="Both" class="box-radio half"> Both </span>
            </nz-radio-group>
            <div
              class="ant-form-item-explain-error mt-3"
              *ngIf="
                !functionalAssessmentForm.value.levelEscape &&
                functionalAssessmentForm.value.levelEscapeScore > 0
              ">
              Please select level.
            </div>
          </div>
        </nz-form-item>
        <nz-divider />
      </form>
      <form
        nz-form
        class="form"
        nzLayout="horizontal"
        [formGroup]="functionalAssessmentForm"
        *ngSwitchCase="2">
        <nz-divider />
        <nz-form-item>
          <nz-form-label nzRequired="true">
            <p class="form-desc">
              You have indicated that one of the possible functions of this
              behavior is attention, meaning to avoid, delay, or get out of
              certain tasks, activities, or settings. To help us identify more
              specific interventions that are most likely to help, please answer
              the following question:<br /><br />
              Is {{ caseDetail.student.firstName }} more likely to try escaping
              from social situations and interactions with peers, or from tasks
              and demands placed on
              {{ caseDetail.student.gender === 'Female' ? 'her' : 'him' }}
              by adults?
            </p>
          </nz-form-label>
          <div class="radio-wrapper">
            <nz-radio-group
              id="languageLevel"
              nzName="radiogroup"
              formControlName="levelAttention">
              <span nz-radio nzValue="Peers" class="box-radio"> Peers </span>
              <span nz-radio nzValue="Adults" class="box-radio"> Adults </span>
              <span nz-radio nzValue="Both" class="box-radio half"> Both </span>
            </nz-radio-group>
            <div
              class="ant-form-item-explain-error mt-3"
              *ngIf="
                !functionalAssessmentForm.value.levelAttention &&
                functionalAssessmentForm.value.levelAttentionScore > 0
              ">
              Please select level.
            </div>
          </div>
        </nz-form-item>
      </form>
      <div *ngSwitchCase="3">
        <div class="mb-16">
          <span class="description mb-24" *ngIf="graphData.length > 0">
            The results suggest the following function(s):
          </span>
          <ul class="function-list-bullets" *ngIf="graphData.length > 0">
            <li *ngFor="let func of getFuncations()">{{ func }}</li>
          </ul>
        </div>
        <div class="graph-content mb-24">
          <app-screener-results-graph
            [graphData]="graphData"
            [chartId]="'assessment-chart_' + generateRandomId" />
        </div>
      </div>
      <div *ngSwitchCase="4">
        <div class="header-with-cta mb-24">
          <h3 class="title s-24">Behavior Screener</h3>
          <div class="cta-wrapper" *ngIf="isEdit">
            <button
              nz-button
              nzType="default"
              [nzLoading]="isPrintLoading"
              (click)="print()"
              [disabled]="behaviourAssessment.length === 0">
              <svg-icon
                src="/assets/icon/icon-printer.svg"
                class="icon s-20"></svg-icon>
              Print
            </button>
          </div>
        </div>
        <div>
          <p class="description mb-24" *ngIf="isEdit">
            The current behavior screener is summarized below.
          </p>
          <p class="description mb-24" *ngIf="!isEdit">
            Press Save Button to save the following behavior screener.
          </p>
          <h3 class="screener-title">Functions:</h3>
          <ul class="function-list-bullets">
            <li *ngFor="let item of getFuncations()">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="display-flex justify-content-between drawer-footer">
      <div class="footer-left">
        <button nz-button type="button" nzType="default" (click)="onCancel()">
          Cancel
        </button>
        <button
          *ngIf="stepNumber === 0 && currentQuestion < 15"
          nz-button
          type="button"
          nzType="default"
          [disabled]="currentQuestion === 15 || stepNumber !== 0"
          (click)="saveForLater()">
          Save for later
        </button>
      </div>
      <div class="footer-right">
        <button
          *ngIf="!isEdit"
          nz-button
          type="button"
          nzType="default"
          (click)="goToPre()"
          [disabled]="stepNumber === 0 && currentQuestion === 0">
          Prev
        </button>
        <button
          nz-button
          *ngIf="!isEdit && !isFinalStep"
          type="button"
          nzType="primary"
          [disabled]="!isCurrentStepValid()"
          (click)="goToNext()">
          Next
        </button>
        <button
          nz-button
          *ngIf="isEdit"
          type="button"
          nzType="primary"
          (click)="edit()">
          Edit
        </button>
        <button
          *ngIf="isFinalStep"
          nz-button
          type="button"
          nzType="primary"
          [disabled]="!isCurrentStepValid()"
          (click)="submit()">
          Save
        </button>
      </div>
    </div>
  </div>
</nz-spin>
